<template>
  <div>
    <template v-for="(blockObject, index) in rootElement.blockObjects">
      <block
        v-if="blockObject.className == 'Block'"
        :block="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
        @updated="updated($event)"
      />
      <FreeText
        v-if="blockObject.className == 'FreeText'"
        :element="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
        @updated="updated($event)"
      />
      <Hr
        v-if="blockObject.className == 'Hr'"
        :hr="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
      />
      <ListElement
        v-if="blockObject.className == 'ListElement'"
        :listElement="rootElement.blockObjects[index]"
        :entryItems="entryItems"
        :key="blockObject.id"
        @updated="updated($event)"
      />
      <MultiEntry
        v-if="blockObject.className == 'MultiEntry'"
        :multiEntry="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
        @updated="updated($event)"
      />
      <Qa
        v-if="blockObject.className == 'Qa'"
        :qa="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
        @updated="updated($event)"
      />
      <SectionElement
        v-if="blockObject.className == 'SectionElement'"
        :sectionElement="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
        @updated="updated($event)"
      />
      <SnippetInsert
        v-if="blockObject.className == 'SnippetInsert'"
        :snippetInsert="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
        @updated="updated($event)"
      />
      <Spacer
        v-if="blockObject.className == 'Spacer'"
        :spacer="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
      />
      <Table
        v-if="blockObject.className == 'Table'"
        :table="blockObject"
        :entryItems="entryItems"
        :key="blockObject.id"
        @updated="updated($event)"
      />
    </template>
  </div>
</template>

<script>
import FreeText from "@/components/document/generator/block/FreeText";
import Hr from "@/components/document/generator/block/Hr";
import ListElement from "@/components/document/generator/block/ListElement";
import MultiEntry from "@/components/document/generator/block/multientry/MultiEntry";
import Qa from "@/components/document/generator/block/qa/Qa";
import SectionElement from "@/components/document/generator/element/SectionElement";
import SnippetInsert from "@/components/document/generator/block/SnippetInsert";
import Spacer from "@/components/document/generator/block/Spacer";
import Table from "@/components/document/generator/block/table/Table";
export default {
  name: "RootElement",
  props: ["rootElement", "entryItems"],
  components: {
    FreeText,
    Hr,
    ListElement,
    MultiEntry,
    Qa,
    SectionElement,
    SnippetInsert,
    Spacer,
    Table
  },
  methods: {
    updated(event) {
      this.$emit("updated", event);
    }
  }
};
</script>
